module.exports = __webpack_public_path__ + "img/03-3市场渗透率分析.db17daf2.png";